export default {
  message: {
    introduce: '一个简单的Vue弹幕插件',
    start: '开始使用',
    doc: '查看文档',
    title1: '容易使用',
    content1: '只需几行代码,简单配置即可使用。',
    title2: '高性能',
    content2: '过百条同屏弹幕依然能保持60FPS.',
    title3: '独立',
    content3: '弹幕数据部分交还给使用者自己管理，可以配合Vuex使用'
  }
}